
import * as utils from './utils.js';
import config from './config.js';
import * as apiHandler from './api-handler.js';
import * as ui from './ui.js';

/** Functions for log and track users actions */
const navigator = window.navigator;
const location = window.location;

export async function trackUser() {
  // Fetch IP details from Cloudflare
  let data = { ip: "127.0.0.1", loc: "unknown", uag: "unknown" };
  try {

    const _resource = utils.isSameResources();
    const arabCountries = new Set(['EG', 'KW', 'SA', 'AE', 'QA', 'BH', 'IQ', 'SY', 'OM', 'JO', 'PS', 'MA', 'TN', 'DZ']);
    let ip = utils.getCookie('ip');
    let country = utils.getCookie('country');
    let device = navigator.userAgent;
    let url = window.location.href;
    let isDownload = utils.isDownloadPage();
    // Return immediately if resource is the same

    if (_resource.isSameResource) {
      return { ip: "127.0.0.1" };
    }
    // in case of cach ip & country

    if (ip == null || country == null) {
      try {
        data = await window.fetch("https://www.cloudflare.com/cdn-cgi/trace")
          .then(res => res.text())
          .then(text => utils.parseCloudflareResponse(text));
      } catch (error) {
        console.log('Possibly blocked by extension or network error:', error);
        // Handle fallback or UI warning
      }
      ip = data.ip;
      country = data.loc;
      device = data.uag;
    } else {
      // get cach data from cookies
      data = { ip: ip, loc: country, uag: device };
    }



    let logUser = utils.createLogUser(data, url);
    // first check if user block ads or not
    // if (isAdBlockerActive()) {
    //   return blockAdUsers(logUser);
    // }

    // Cache country & IP
    if (!utils.getCookie('country')) utils.setCookie('country', country, 1500);
    if (!utils.getCookie('ip')) utils.setCookieInMinutes('ip', ip, 10);

    let isArabCountry = arabCountries.has(country);
    // console.log(isArabCountry);
    if (!isArabCountry) {
      let dbResponse = await apiHandler.fetchUserBlockStatus(ip);

      if (dbResponse && dbResponse.block > 0) {

        handleBlockedUser(dbResponse, logUser, data);
      } else {

        processAllowedUser(logUser, data);
      }
    } else {

      processAllowedUser(logUser, data);
    }

    return data;
  } catch (error) {
    console.error(error);
    return data;
  }
}

/**
 * Handles blocked users by disabling input fields or restricting access.
 */
function handleBlockedUser(data, logUser, cloudData) {
  const mainContainer = document.querySelector('.main-container');
  if (utils.isCrawler(data.isp, cloudData.uag)) {
    ui.disableUserInput();
    logUser.dotnetHost = utils.getCrawlerType(data.isp, cloudData.uag);
    apiHandler.logUsersOfDesign(logUser);
  } else {
    // TEMP (lane only, 2026-10-29): proxy block disabled so the automated
    // checks can run - RESTORE this line right after they finish.
    // ui.restrictUserAccess(mainContainer, logUser);
  }
}

function processAllowedUser(logUser, data) {
  let mainContainer = document.querySelector('.main-container');

  let _totalDownload = utils.getCookie(config.totaldowloadKey);
  let _totalDesigns = utils.getCookie(config.designName);
  logUser.totalDownload = _totalDownload != null ? _totalDownload : 0;
  logUser.totalDesigns = _totalDesigns != null ? _totalDesigns : 0;

  if (utils.isDisableCookies()) {
    //  (mainContainer, data);
  } else {

    apiHandler.logUsersOfDesign(logUser);
  }
}

export function logUserExtraDetails(exception, invalidData) {
  const flag = utils.getCookie("_flag");
  const ip = utils.getCookie("ip") ?? "";
  const country = utils.getCookie("country") ?? "";
  let _totalDownload = utils.getCookie(config.totaldowloadKey);
  let designCount = utils.getCookie(config.designName);

  // collect extra info
  let device = navigator.userAgent;
  let url = location.href;
  let logUser = utils.createLogUser({ ip, loc: country, uag: device }, url);
  let _totalDesigns = designCount != null ? parseInt(designCount) : 0;
  let isExccedTotalDownload = 0;
  let isExceedDesign = 0;
  if (_totalDownload != null) {
    if (parseInt(_totalDownload) >= parseInt(config.maxTotalDownloadPerCountry)) {
      isExccedTotalDownload = 1;
    }
  }
  if (settingData.general.countofattemp != null) {
    if (parseInt(settingData.general.countofattemp) >= parseInt(_totalDesigns)) {
      isExceedDesign = 1;
    }
  }
  if (exception != undefined)
    logUser.exception = exception;
  if (invalidData != undefined)
    logUser.invalidData = invalidData;

  logUser.isExceedDesign = isExceedDesign;
  logUser.isExceedTotalDownload = isExccedTotalDownload;
  logUser.flag = flag != null ? flag : "";
  logUser.totalDownload = _totalDownload != null ? _totalDownload : 0;
  logUser.totalDesigns = _totalDesigns;
  apiHandler.logUsersOfDesign(logUser);
}

